import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseInquiryService } from '../_services/base-inquiry.service';
import { BaseFilterService } from '../../../shared/services/base-filter.service';
import { BaseQueryParamService } from '../../../shared/services/base-query-param.service';
import { BaseCustomerInquiryFilters } from '../_enums/base-inquiry.enum';

export abstract class BaseAbstractFiltersAndActionsClass {
  isLegendVisible = false;
  isFiltersVisible = false;
  activeFiltersAmount: number;
  filtersForm: FormGroup;

  protected constructor(
    protected baseInquiryService: BaseInquiryService,
    public filterService: BaseFilterService,
    public queryParamsService: BaseQueryParamService,
    public activatedRoute: ActivatedRoute
  ) {}

  showSidebar(): void {
    this.baseInquiryService.toggleInquirySidebarSubject$.next(true);
  }

  toggleLegendVisibility(): void {
    this.isLegendVisible = !this.isLegendVisible;
    if (this.isLegendVisible) {
      this.isFiltersVisible = false;
    }
  }

  toggleFilterVisibility(): void {
    this.isFiltersVisible = !this.isFiltersVisible;
    if (this.isFiltersVisible) {
      this.isLegendVisible = false;
    }
    this.activeFiltersAmount = this.filterService.updateActiveFilters(this.filtersForm.value).length;
  }

  onSearchChange(query: string): void {
    this.filtersForm.controls[BaseCustomerInquiryFilters.search].setValue(query);
    this.queryParamsService.filterSubject.next({
      page: this.activatedRoute.snapshot.queryParams.page,
      filters: this.filtersForm.value,
    });
  }
}
